// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/Images/Map_background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForestPage{
    background: #FCF6F2;
    position: fixed;
    height: 100vh;
    width: 100%;
}

.ForestSelection{
    display: flex;
    padding: 4%;
    flex-wrap: wrap;
    justify-content: space-between;
}

.ForestMap{
    display: block;
    position: relative;
    width: 50%;
    height: 481px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
}

.ForestMap>img{
    width: 90%;
    object-fit: contain;
}

.ForestList{
    width: 40%;
    height: max-content;
}

.ForestListCard{
    width: 90%;
    padding: 4%;
    height: fit-content;
    background: #FFFF;
    display: flex;
    flex-direction: column;
}

.Forest_Card_Heading{
    font-weight: 600;
    font-size: 24px;
    color: #3F3325;
    line-height: 36px;
}

.ForestListRow{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: inherit;
}

.ForestListRow>.Forest{
    width: 80%;
    align-items: center;
    padding-bottom: 10px;
    display: grid;
    grid-template-columns: 25% 70%;
    height: 100%;
    border-bottom: 1px solid;
    border-bottom-style: groove;
}

.ForestListRow>.ForestCheck{
    width: 10%;
    align-items: center;
    height: 50%;
    display: grid;
}  


.ForestListRow>.ForestCheck>input{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    outline: none;
    border: 1.5px solid #E8DFD5;
    cursor: pointer;
}


.ForestListRow>.ForestCheck>input:before {
    content: '';
    display: block;
    width: 60%;
    height: 60%;
    margin: 20% auto;
    border-radius: 50%;
}

.ForestListRow>.ForestCheck>input:checked:before {
    background: #48887B;
    
}

.ForestListRow>.ForestCheck>input:checked {
  border-color:#48887B;
}



.Forest_name>span{
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #594F42;
}
.Forest_img>img{
    object-fit: contain;
    height: 60px;
}

.Forest_Proceed{
    display: none;
    grid-column-start: 1;
    grid-column-end: 3;
    opacity: 0;
    transition: opacity 1s ease-in-out 3s;
}

.selected_forest{
    opacity: 1;
    display: block;
    transition: all 0.4s ease;


}

.location_pointer {
    cursor: pointer;
    display: grid;
    position: absolute;
    top: 15%;
    left: 15%;
    grid-row-gap: 30%;
    width: 50%;
    grid-column-gap: 250px;
    grid-template-columns: 50% 50%;
}

.location_pointer>img{
    object-fit: contain;
}

.location_pointer>.img0{
    margin-left: 20%
}

.location_pointer>.img0,.img3{
    grid-column-start: 1;
    grid-column-end: 3;
}

.location_pointer>.img3{
    margin-top: 7%
}

.location_pointer>.img4{
    margin-top: 20%
}`, "",{"version":3,"sources":["webpack://./src/CSS/Forest.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mDAAsD;IACtD,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;;AAEvB;;AAEA;EACE,oBAAoB;AACtB;;;;AAIA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,cAAc;IACd,yBAAyB;;;AAG7B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ","sourcesContent":[".ForestPage{\n    background: #FCF6F2;\n    position: fixed;\n    height: 100vh;\n    width: 100%;\n}\n\n.ForestSelection{\n    display: flex;\n    padding: 4%;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.ForestMap{\n    display: block;\n    position: relative;\n    width: 50%;\n    height: 481px;\n    background: url('../Assets/Images/Map_background.png');\n    background-size: contain;\n}\n\n.ForestMap>img{\n    width: 90%;\n    object-fit: contain;\n}\n\n.ForestList{\n    width: 40%;\n    height: max-content;\n}\n\n.ForestListCard{\n    width: 90%;\n    padding: 4%;\n    height: fit-content;\n    background: #FFFF;\n    display: flex;\n    flex-direction: column;\n}\n\n.Forest_Card_Heading{\n    font-weight: 600;\n    font-size: 24px;\n    color: #3F3325;\n    line-height: 36px;\n}\n\n.ForestListRow{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: inherit;\n}\n\n.ForestListRow>.Forest{\n    width: 80%;\n    align-items: center;\n    padding-bottom: 10px;\n    display: grid;\n    grid-template-columns: 25% 70%;\n    height: 100%;\n    border-bottom: 1px solid;\n    border-bottom-style: groove;\n}\n\n.ForestListRow>.ForestCheck{\n    width: 10%;\n    align-items: center;\n    height: 50%;\n    display: grid;\n}  \n\n\n.ForestListRow>.ForestCheck>input{\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    outline: none;\n    border: 1.5px solid #E8DFD5;\n    cursor: pointer;\n}\n\n\n.ForestListRow>.ForestCheck>input:before {\n    content: '';\n    display: block;\n    width: 60%;\n    height: 60%;\n    margin: 20% auto;\n    border-radius: 50%;\n}\n\n.ForestListRow>.ForestCheck>input:checked:before {\n    background: #48887B;\n    \n}\n\n.ForestListRow>.ForestCheck>input:checked {\n  border-color:#48887B;\n}\n\n\n\n.Forest_name>span{\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    color: #594F42;\n}\n.Forest_img>img{\n    object-fit: contain;\n    height: 60px;\n}\n\n.Forest_Proceed{\n    display: none;\n    grid-column-start: 1;\n    grid-column-end: 3;\n    opacity: 0;\n    transition: opacity 1s ease-in-out 3s;\n}\n\n.selected_forest{\n    opacity: 1;\n    display: block;\n    transition: all 0.4s ease;\n\n\n}\n\n.location_pointer {\n    cursor: pointer;\n    display: grid;\n    position: absolute;\n    top: 15%;\n    left: 15%;\n    grid-row-gap: 30%;\n    width: 50%;\n    grid-column-gap: 250px;\n    grid-template-columns: 50% 50%;\n}\n\n.location_pointer>img{\n    object-fit: contain;\n}\n\n.location_pointer>.img0{\n    margin-left: 20%\n}\n\n.location_pointer>.img0,.img3{\n    grid-column-start: 1;\n    grid-column-end: 3;\n}\n\n.location_pointer>.img3{\n    margin-top: 7%\n}\n\n.location_pointer>.img4{\n    margin-top: 20%\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
